<template>
  <div class="software-license-view">
    <div v-html="softwareLicenseText" />
  </div>
</template>

<script>
import SoftwareLicenseService from '@/domain/services/generalPanel/softwareLicense';

export default {
  data() {
    return {
      softwareLicenseText: null,
    };
  },
  created() {
    this.getLicense();
  },
  methods: {
    getLicense() {
      SoftwareLicenseService.getLicense().then((license) => {
        this.softwareLicenseText = license;
      });
    },
  },
};
</script>
<style lang="sass" scoped>
.software-license-view
  @media print
    margin: 8mm 8mm 0 8mm

    ::v-deep
      .app-content__main-content
        padding: 0

</style>
